import { colorThemeGenerator } from '@spotify-internal/encore-creator-web';

export const WRAPPED_BUTTON_COLOR_DEFAULT = '#cff56a';
export const WRAPPED_BUTTON_COLOR_ACTIVE = '#e5ac8a';

// TODO: swap with production URL ahead of launch:
// https://wrappedforpodcasters.byspotify.com/
export function getWrappedMicrositeUrl(externalPodcastId: string) {
  return `https://podcasters-dot-wrapped-2021.appspot.com/?id=${externalPodcastId}`;
}

export function getWrappedButtonTheme() {
  return colorThemeGenerator({
    primaryColor: WRAPPED_BUTTON_COLOR_DEFAULT,
    primaryColorHover: WRAPPED_BUTTON_COLOR_ACTIVE,
  });
}
